import React, { useState, useContext } from 'react'
import { StateContext } from '../../services/StateService'
import ProductSelector from './ProductSelector'
import CTASection from './CTASection'
import WhereToBuyController from './WhereToBuyController'
import ServiceLocator from './ServiceLocator'
import '../../css/PurchaseOptions.scss'

const PurchaseOptions = ({
    supportRef,
    supportSecondaryRef,
    supportTertiaryRef,
    productOptionsRef,
    prodOptButtonRef,
    getProductEndpoint,
    handleProductSelectorRequest
}) => {
    const { isParent, ctaInfo } = useContext(StateContext)
    const [displaySelectors, setDisplaySelectors] = useState(false)

    return (
        <div className="sps2-pdp_purchase--container">
            {isParent && !ctaInfo?.pdpSelectorOverride && (
                <ProductSelector
                    prodOptButtonRef={prodOptButtonRef}
                    handleProductSelectorRequest={handleProductSelectorRequest}
                    displaySelectors={displaySelectors}
                    setDisplaySelectors={setDisplaySelectors}
                />
            )}
            <WhereToBuyController
                displaySelectors={displaySelectors}
                getProductEndpoint={getProductEndpoint}
            />
            <CTASection
                productOptionsRef={productOptionsRef}
                prodOptButtonRef={prodOptButtonRef}
                supportRef={supportRef}
                supportSecondaryRef={supportSecondaryRef}
                supportTertiaryRef={supportTertiaryRef}
            />
            {ctaInfo?.serviceLocatorWidgetId && ctaInfo?.serviceLocatorSubId && (
                <ServiceLocator
                    widgetId={ctaInfo.serviceLocatorWidgetId}
                    subId={ctaInfo.serviceLocatorSubId}
                />
            )}
        </div>
    )
}

export default PurchaseOptions
